var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarSolid = function SvgCalendarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "calendar-solid_svg__cls-1",
    d: "M3 3a2 2 0 0 0-2 2v3h18V5a2 2 0 0 0-2-2H3ZM19 10H1v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "calendar-solid_svg__cls-1",
    d: "M6 1a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V2a1 1 0 0 0-1-1ZM14 1a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V2a1 1 0 0 0-1-1Z"
  })));
};
export default SvgCalendarSolid;